/** Inline hint next to “Measurement Probabilities” (ket bit order; matches wire indices). */
export const MEASUREMENT_ORDERING_HINT =
  'Left bit = qubit 0 (first wire); read kets left to right';

/**
 * Ket label for a simulator amplitude index. Quirk stores wire 0 as the LSB in the
 * index; we reverse bits so the displayed ket reads left-to-right (qubit 0 on the left).
 * @param {number} amplitudeIndex
 * @param {number} numWires
 * @returns {string}
 */
export function measurementKetLabel(amplitudeIndex, numWires) {
  const padded = amplitudeIndex.toString(2).padStart(Math.max(numWires, 1), '0');
  const leftToRight = padded.split('').reverse().join('');
  return `|${leftToRight}\u27E9`;
}
